import React from 'react';
import ErrorWrapper from '@/app/ErrorWrapper';
import { useEffect, useState } from 'react';
import { teachersApi } from '@/api/teachers/teachersApi';
import { Card, List, Modal } from 'antd';
import { useTranslation } from 'react-i18next'; // Added import
const { Meta } = Card;

const TeacherModalComponent = ({
    open,
    handleToggleModal,
    handleSelectTeacher,
    selectedTeacher
}) => {
    const { t } = useTranslation(); // Added hook
    const [data, setData] = useState([]);
    const [isLoadingData, setIsLoadingData] = useState(true);
    const [selected, setSelected] = useState(selectedTeacher);
    const [pagination, setPagination] = useState({
        page: 1,
        pageSize: 6,
        total: 0
    });
    const getList = () => {
        teachersApi
            .getList({
                page: pagination.page,
                pageSize: pagination.pageSize
            })
            .then((res) => {
                setIsLoadingData(false);
                setData(res.data.data.rows);
                setPagination({ ...pagination, total: res.data.data.total });
            })
            .catch((err) => console.error(err));
    };
    useEffect(() => {
        getList();
    }, [pagination.page]);

    return (
        <Modal
            open={open}
            title={t('TeacherModal_Title')} // Added title
            onCancel={handleToggleModal}
            closable={false}
            onOk={() => {
                handleToggleModal();
                handleSelectTeacher(selected);
            }}
            okText={t('TeacherModal_Button_Ok')} // Added okText
            cancelText={t('TeacherModal_Button_Cancel')} // Added cancelText
            okButtonProps={{ disabled: !selected }}>
            <List
                grid={{
                    gutter: 16,
                    xs: 1,
                    sm: 2,
                    md: 4,
                    lg: 4,
                    xl: 6,
                    xxl: 3
                }}
                loading={isLoadingData}
                pagination={{
                    pageSize: pagination.pageSize,
                    current: pagination.page,
                    total: pagination.total,
                    onChange: (e) => setPagination({ ...pagination, page: e })
                }}
                dataSource={data}
                renderItem={(item) => {
                    return (
                        <List.Item>
                            <Card
                                className={`cursor-pointer ${
                                    selected?.id === item?.id ? 'border-1 border-red-500' : ''
                                }`}
                                title={item.title}
                                onClick={() => setSelected(item)}
                                cover={
                                    <div className="w-full !flex items-center justify-center p-2">
                                        <img
                                            className="w-[50%] rounded-xl"
                                            draggable={false}
                                            alt={t('TeacherModal_Avatar_Alt')} // Updated alt text
                                            src={
                                                item?.avatar
                                                    ? item?.avatar
                                                    : item?.gender == 'Male'
                                                    ? '/assets/images/avatar_male.png'
                                                    : '/assets/images/avatar_female.png'
                                            }
                                        />
                                    </div>
                                }>
                                <Meta
                                    className="text-center"
                                    title={`${item?.firstName} ${item?.lastName}`}
                                />
                            </Card>
                        </List.Item>
                    );
                }}
            />
        </Modal>
    );
};

TeacherModalComponent.displayName = 'TeacherModal';

const TeacherModal = (props) => {
    return (
        <ErrorWrapper>
            <TeacherModalComponent
                data-id="TeacherModal-cpn"
                {...props}
            />
        </ErrorWrapper>
    );
};

export default TeacherModal;
